import { MainLayout } from '@components/layouts/main.layout';
import { TechnologiesGridTile } from '@components/pages/home/components/technologies-tile.component';
import { TechnologyEffectsTile } from '@components/pages/technology/components/technology-effects-tile.component';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { TechnologiesTrlSpectrumTile } from '@components/shared/technologies-trl-spectrum-tile.component';
import { TechnologyOriginsSankeyTile } from '@components/shared/technology-origins-sankey.component';
import { useTechnologiesQueryOptions } from '@queries/technology.query';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const TechnologiesPage: React.FC = () => {
  const { data: user, isPending: isUserPending } = useGetCurrentUser();
  const technologiesQueryOptions = useTechnologiesQueryOptions();
  const { data: technologies, isPending: isTechnologiesPending } = useQuery(technologiesQueryOptions);

  const navigate = useNavigate();
  const company = user?.companies?.[0];

  useEffect(() => {
    if (!isUserPending && !company) {
      navigate(routes.home.path);
    }
  }, [isUserPending, company, navigate]);

  const isLoading = isUserPending || isTechnologiesPending;
  const hasTechnologies = technologies && technologies.length > 0;

  return (
    <PageviewTracker>
      <HelmetWrapper title="Technologies" />
      <MainLayout
        aside={<TechnologiesGridTile />}
        asideClassName={
          hasTechnologies ? 'order-1 @min-[56rem]/main:order-2' : 'order-1 w-full @min-[56rem]/main:max-w-[70%]'
        }
        columnsStartAtContainer="56rem"
        contentClassName={hasTechnologies ? 'order-2 @min-[56rem]/main:order-1' : 'hidden'}
      >
        {!isLoading && hasTechnologies && (
          <div className="flex-col flex gap-4">
            <TechnologyOriginsSankeyTile sankeyProps={{ maxHeight: 500 }} />
            <TechnologyEffectsTile sankeyProps={{ maxHeight: 500 }} />
            <TechnologiesTrlSpectrumTile
              header={{ title: 'Technology Pipeline' }}
              technologies={technologies}
            />
          </div>
        )}
      </MainLayout>
    </PageviewTracker>
  );
};
